import React, { useState, useEffect } from 'react'
import { makeStyles } from '@mui/styles'
import { Box, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/InfoRounded'

import lang from '@/lang'
import DOSelect from '@/modules/base/components/inputs/do-select'
import RichTooltip from '@/modules/base/components/rich-tooltip/rich-tooltip'

const getType = (type) => {
  switch (type) {
    case 'string':
      return '(Alphanumerisch)'
    case 'number':
      return '(Numerisch)'
    case 'boolean':
      return '(Ja / Nein)'
    default:
      return ''
  }
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 10,
    '& > div': {
      height: 45,
      flex: '1 1 50%',
      minWidth: 0,
    },
    '& .MuiSelect-select': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  given: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexGrow: 1,
    marginLeft: 32,
    minWidth: 0,
  },
  givenField: {
    fontWeight: '600',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  givenType: {
    fontWeight: '200',
  },
  required: {
    color: theme.palette.primary.main,
  },
  tooltip: {
    fontSize: theme.fontSizes.smaller,
    color: theme.black,
  },
}))

interface IImportItem {
  label: string
  key: string
  tooltip: string
  required: boolean
  requiredGroup?: string
  type: string
  typeLabel?: string
}

interface IColumns {
  [key: string]: string
}

interface IOnChangeData {
  [key: string]: IImportItem | null
}

interface IMassImportAssignmentItemProps {
  value: string
  importItem: IImportItem
  importType: string
  columns: IColumns
  usedColumns: IColumns
  onChange: (data: IOnChangeData) => void
}

const MassImportAssignmentItem = (props: IMassImportAssignmentItemProps) => {
  const {
    importItem = {} as IImportItem,
    importType = '',
    columns,
    usedColumns,
    onChange,
    value: initValue = '-1',
  } = props

  const classes = useStyles()

  // const [importSchema, setImportSchema] = useState({})
  const [value, setValue] = useState(initValue)

  const displayColumns = value !== '-1' ? { [value]: usedColumns[value], ...columns } : columns

  const textInputValue = importItem.label || lang.massImport2.importDefs[importType]?.fields[importItem.key] || importItem.key || ''

  useEffect(() => {
    setValue(initValue)
  }, [initValue])

  const handleChange = (event) => {
    const key = event.target.value
    setValue(key)
    const onChangeData = { }
    if (key !== '-1') {
      onChangeData[key] = importItem
    }
    if (value) {
      onChangeData[value] = null
    }
    onChange(onChangeData)
  }

  // const renderValue = (selected) => (!selected ? 'nicht zugeordnet' : `${displayColumns[selected]} (${selected})`)

  const options = [{ value: '-1', label: 'nicht zugeordnet' }, ...Object.keys(displayColumns).map((key) => ({ value: key, label: `${displayColumns[key]} (${key})` }))]

  return (
    <div className={classes.container}>
      <DOSelect value={value} onChange={handleChange} options={options} />
      <div className={classes.given}>
        <Box display='flex' gap={1}>
          <Typography variant='body1' className={classes.givenField}>
            {textInputValue}
            {importItem.required && <span className={classes.required}>*</span>}
          </Typography>
          {importItem.tooltip && (
            <RichTooltip styles={{ tooltip: classes.tooltip }} content={importItem.tooltip}>
              <InfoIcon />
            </RichTooltip>
          )}
        </Box>
        <Box>
          <Typography variant='body1' className={classes.givenType}>{`${importItem.typeLabel || getType(importItem.type)}`}</Typography>
        </Box>
      </div>
    </div>
  )
}

export default MassImportAssignmentItem
